export async function shareStreakImage({ streak, name }) {
  try {
    await document.fonts.load('100px "Bebas Neue"');
  } catch (e) {
    console.warn("Police Bebas Neue non chargée:", e?.message);
  }
  const W = 1080, H = 1080;
  const c = document.createElement("canvas");
  c.width = W; c.height = H;
  const ctx = c.getContext("2d");

  ctx.fillStyle = "#0A0A0A";
  ctx.fillRect(0, 0, W, H);
  ctx.strokeStyle = streak >= 4 ? "#FF3B30" : "#FFC107";
  ctx.lineWidth = 14;
  ctx.strokeRect(40, 40, W - 80, H - 80);

  ctx.textBaseline = "top";
  ctx.fillStyle = "#FFFFFF";
  ctx.font = '90px "Bebas Neue", sans-serif';
  ctx.fillText("GYM", 90, 90);
  const w1 = ctx.measureText("GYM").width;
  ctx.fillStyle = "#FF3B30";
  ctx.fillText("TRACK", 90 + w1, 90);

  ctx.textAlign = "center";
  ctx.font = `${Math.min(300, 200 + streak * 10)}px Arial`;
  ctx.fillText("🔥", W / 2, 230);

  ctx.fillStyle = "#FF3B30";
  ctx.font = '280px "Bebas Neue", sans-serif';
  ctx.fillText(`${streak}`, W / 2, 540);

  ctx.fillStyle = "#FFFFFF";
  ctx.font = '90px "Bebas Neue", sans-serif';
  ctx.fillText(`SEMAINE${streak > 1 ? "S" : ""} DE SUITE`, W / 2, 820);

  ctx.fillStyle = "#888888";
  ctx.font = "38px Arial, sans-serif";
  ctx.fillText("Chaque série à l'échec · Pas d'excuses", W / 2, 930);

  ctx.textAlign = "left";
  ctx.fillStyle = "#666666";
  ctx.font = "34px Arial, sans-serif";
  ctx.fillText(`${name}  ·  ${new Date().toISOString().slice(0, 10)}`, 90, H - 130);

  const blob = await new Promise((res) => c.toBlob(res, "image/png"));
  const file = new File([blob], `streak-${Date.now()}.png`, { type: "image/png" });
  if (navigator.canShare && navigator.canShare({ files: [file] })) {
    try {
      await navigator.share({ files: [file], title: `${streak} semaines de suite au gym 🔥` });
      return "shared";
    } catch (e) {
      if (e.name === "AbortError") return "cancelled";
    }
  }
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = file.name;
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 5000);
  return "downloaded";
}
